import React from 'react';
import '../styles/PageAbout.css';

function PageAbout() {
	return (
		<div className="about">
			<div className="overlay">
				<header className="about-header">
					<h1>O nas</h1>
					<p>
						Jesteśmy rodzinną firmą z małopolski na pograniczu Podhala i Beskidu Wyspowego. Zajmujemy się sprzedażą kwiatów sztucznych i dodatków. W swojej pracy stawiamy na jakość. Śledzimy bieżące trendy z branży dzięki czemu możemy dać Wam szansę na tworzenie modnych i wyjątkowych rzeczy. Nasze kwiaty i dodatki świetnie sprawują się w dekoracjach okolicznościowych (na przyklad wianki, stroiki, bukiety), ale również w kompozycjach nagrobnych. Dzięki możliwości sprzedaży i wysyłki na terenie UE nie ma dla nas granic!
					</p>
				</header>
			</div>
		</div>
	);
}

export default PageAbout;
